import { ChangeEvent } from 'react';
import HoverButton from './HoverButton';
import InputField from './InputField';
import { useTranslation } from 'react-i18next';

interface MaltInputProps {
  Id: number;
  Name: string;
  Weight: number | string;
  Extract: number | string;
  Color: number | string;
  Content: string;
  removeMalt: (id: number) => void;
  handleInputChange: (e: ChangeEvent<HTMLInputElement>, id: number) => void;
}

function MaltInput({ Id, Name, Weight, Extract, Color, Content, removeMalt, handleInputChange }: MaltInputProps) {
  const { t } = useTranslation();
  return (
    <div className="py-3 border-b border-border last:border-b-0 last:pb-0">
      {/* Mobile */}
      <div className="sm:hidden space-y-2">
        <div className="flex gap-2 items-end">
          <div className="flex-1 min-w-0">
            <InputField
              type="text"
              name="Name"
              value={Name}
              onChange={e => handleInputChange(e, Id)}
              placeholder={t('recipe.maltPlaceholder')}
            />
          </div>
          <div className="w-24 shrink-0">
            <InputField unit="kg" name="Weight" value={Weight} onChange={e => handleInputChange(e, Id)} />
          </div>
          <div className="shrink-0">
            <HoverButton onClick={() => removeMalt(Id)} btnClass="btn-danger" hoveredIcon="fa-trash-circle" normalIcon="fa-trash" />
          </div>
        </div>
        <div className="grid grid-cols-3 gap-2">
          <InputField unit="%" name="Extract" value={Extract} onChange={e => handleInputChange(e, Id)} />
          <InputField unit="EBC" name="Color" value={Color} step="1" onChange={e => handleInputChange(e, Id)} />
          <InputField unit="%" value={Content} readOnly />
        </div>
      </div>
      {/* Desktop */}
      <div className="hidden sm:grid grid-cols-6 gap-2 items-end">
        <InputField type="text" name="Name" value={Name} onChange={e => handleInputChange(e, Id)} placeholder={t('recipe.maltPlaceholder')} />
        <InputField unit="kg" name="Weight" value={Weight} onChange={e => handleInputChange(e, Id)} />
        <InputField unit="%" name="Extract" value={Extract} onChange={e => handleInputChange(e, Id)} />
        <InputField unit="EBC" name="Color" value={Color} step="1" onChange={e => handleInputChange(e, Id)} />
        <InputField unit="%" value={Content} readOnly />
        <HoverButton onClick={() => removeMalt(Id)} btnClass="btn-danger" hoveredIcon="fa-trash-circle" normalIcon="fa-trash" />
      </div>
    </div>
  );
}

export default MaltInput;
